import { render, staticRenderFns } from "./dealFlow.vue?vue&type=template&id=28c35166&"
import script from "./dealFlow.vue?vue&type=script&lang=js&"
export * from "./dealFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports